import { render, staticRenderFns } from "./likes.vue?vue&type=template&id=774c0a2c&scoped=true&"
import script from "./likes.vue?vue&type=script&lang=js&"
export * from "./likes.vue?vue&type=script&lang=js&"
import style0 from "./likes.vue?vue&type=style&index=0&id=774c0a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c0a2c",
  null
  
)

export default component.exports